import {
  withJsonFormsCellProps,
  withJsonFormsEnumCellProps,
  withJsonFormsOneOfEnumCellProps,
} from '@jsonforms/react';
import { Checkbox, Switch, TimePicker } from 'antd';
import { Select } from '@dynamika-shared/ui/Select/Select';
import { DatePicker } from '@dynamika-shared/ui/DatePicker/DatePicker';
import { InputNumber } from '@dynamika-shared/ui/InputNumber/InputNumber';
import { MaskedInputNumber } from '@dynamika-shared/ui/InputNumber/MaskedInputNumber';
import { Input } from '@dynamika-shared/ui/Input/Input';
import { ControlConfigurationCell } from '@components/uploadForm/Types/ControlConfiguration';

export const controlConfigurationCells: ControlConfigurationCell[] = [
  {
    controlWrapperFunc: withJsonFormsCellProps,
    Component: Checkbox,
    tester: 'BooleanCell',
  },
  {
    controlWrapperFunc: withJsonFormsCellProps,
    Component: Switch,
    tester: 'BooleanToggleCell',
  },
  {
    controlWrapperFunc: withJsonFormsCellProps,
    Component: DatePicker,
    tester: 'DateCell',
  },
  {
    controlWrapperFunc: withJsonFormsEnumCellProps,
    Component: Select,
    tester: 'EnumCell',
  },
  {
    controlWrapperFunc: withJsonFormsOneOfEnumCellProps,
    Component: Select,
    tester: 'OneOfEnumCell',
  },
  {
    controlWrapperFunc: withJsonFormsCellProps,
    Component: InputNumber,
    tester: 'NumberCell',
  },
  {
    controlWrapperFunc: withJsonFormsCellProps,
    Component: InputNumber,
    tester: 'NumberFormatCell',
  },
  {
    controlWrapperFunc: withJsonFormsCellProps,
    Component: MaskedInputNumber,
    tester: 'MaskedNumberFormatCell',
  },
  {
    controlWrapperFunc: withJsonFormsCellProps,
    Component: Input,
    tester: 'TextCell',
  },
  {
    controlWrapperFunc: withJsonFormsCellProps,
    Component: TimePicker,
    tester: 'TimeCell',
  },
];
